/* eslint-disable no-alert */
import { Box, Button, Divider, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useStateContext } from "contexts/ContextProvider";
import SnackbarComponent from "components/smea/Snackbar";
import useAxiosPrivate from "contexts/interceptors/axios";
import FilterModal from "modals/smea/encodingForm/FilterModal";
import EncodingForm from "./EncodingForm";

export default function Form() {
  const { auth } = useStateContext();
  const axiosPrivate = useAxiosPrivate();
  const [schoolDetails, setSchoolDetails] = useState();

  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [competencies, setCompetencies] = useState([]);
  const [competencyDetails, setCompetencyDetails] = useState({
    officeId: auth.officeId,
    gradeLevel: "",
    quarter: "",
    subjectId: "",
    schoolYear: "",
    status: 0,
    data: [],
    averageMPS: 0,
    averageSD: 0,
  });

  const [responseDetails, setResponseDetails] = useState(
    competencies?.map((competency, index) => ({
      competencyId: competency?.id || "",
      competencyNo: competency?.competencyNo || "",
      competencyDesc: competency?.competencyDesc || "",
      mps: competencyDetails?.data[index]?.mps || "",
      sd: competencyDetails?.data[index]?.sd || "",
    }))
  );

  const [openFilter, setOpenFilter] = useState(false);

  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);

  const handleCategoriesUpdate = (updatedData) => {
    setCompetencyDetails((prevData) => ({
      ...prevData,
      status: prevData.status,
      gradeLevel: updatedData.grade,
      quarter: updatedData.quarter,
      subjectId: updatedData.subject,
      schoolYear: updatedData.schoolYear,
      componentId: updatedData.component,
    }));
  };

  const handleDetailsUpdate = (updatedData) => {
    setCompetencyDetails((prevData) => ({
      ...prevData,
      status: updatedData.status,
      data: updatedData.data.map((item) => ({
        ...item,
        competencyId: item?.competencyId || undefined,
        competencyNo: item?.competencyNo || undefined,
        competencyDesc: item?.competencyDesc || undefined,
        mps: item?.mps || undefined,
        sd: item?.sd || undefined,
      })),
      averageMPS: updatedData.mpsAverageTotal,
      averageSD: updatedData.sdAverageTotal,
    }));
  };

  const handleGetCompetencies = (filters) => {
    setLoading(true);
    setError("");

    const categories = { ...filters, officeId: auth.officeId };

    const queryParams = {
      quarter: categories?.quarter,
      gradeLevel: categories?.grade,
      subjectId: categories?.subject,
      schoolYear: categories?.schoolYear,
    };

    // Check if the component field is defined and not an empty string
    if (categories?.component) {
      queryParams.componentId = categories.component;
    }

    if (categories?.officeId) {
      queryParams.officeId = categories.officeId;
    }

    axiosPrivate
      .get(`/competency/filterCompetencies`, {
        params: queryParams,
      })
      .then((e) => {
        const res = e?.data;

        if (res.hasEncoded === true) {
          alert("This set of competency has already been encoded.");
          setOpenFilter(true);
        } else if (res.hasEncoded === false) {
          if (res.melcs.length !== 0) {
            setCompetencies(res.melcs);
            setOpenFilter(false);
          } else if (res.melcs.length === 0) {
            alert(
              "No competencies found for that selection. Please try again."
            );
            setOpenFilter(true);
          }
        }
      })
      .catch((err) => {
        // Handle network errors or any other errors here
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = (promptResponse) => {
    setLoading(true);
    setError("");

    console.log({ competencyDetails });

    axiosPrivate
      .post(`competency/addFormData`, {
        ...competencyDetails,
        status: promptResponse.status,
        schoolYear: competencyDetails.schoolYear.toString(),
        data: competencyDetails.data.map((values) => ({
          competencyId: values.competencyId,
          competencyNo: values.competencyNo,
          competencyDesc: values.competencyDesc,
          mps: parseFloat(values.mps),
          sd: parseFloat(values.sd),
        })),
      })
      .then(() => {
        setCompetencies([]);
        // setCompetencyDetails((prev) => ({
        //   officeId: auth.officeId,
        //   gradeLevel: prev.gradeLevel + 1, // Increment gradeLevel
        //   quarter: "",
        //   subjectId: "",
        //   schoolYear: "",
        //   status: 0,
        //   data: [],
        //   averageMPS: 0,
        //   averageSD: 0,
        // }));
        setResponseDetails([
          {
            competencyId: "",
            competencyNo: "",
            competencyDesc: "",
            mps: "",
            sd: "",
          },
        ]);

        setOpenSuccess(true);
        setOpenFilter(true);
      })
      .catch((err) => {
        setOpenError(true);
        // Handle network errors or any other errors here
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCloseSuccess = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccess(false);
  };

  const handleCloseError = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenError(false);
  };

  const handleGetOfficeDetails = () => {
    setLoading(true);
    setError("");

    axiosPrivate
      .get(`/office/getOfficeById/${auth?.officeId}`)
      .then((e) => {
        setSchoolDetails(e.data);
      })
      .catch((err) => {
        // Handle network errors or any other errors here
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetOfficeDetails();
  }, []);

  // console.log(competencyDetails);

  return (
    <Box
      sx={{
        display: "block",
        backgroundColor: "#f0f0f0",
        overflowY: "hidden",
        p: "20px",
      }}
    >
      <FilterModal
        open={openFilter}
        handleClose={() => setOpenFilter(false)}
        fetchCompetencies={handleGetCompetencies}
        onDetailsUpdate={handleCategoriesUpdate}
        competencyDetails={competencyDetails}
        schoolDetails={schoolDetails}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          minWidth: "600px",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          boxShadow: "3px 2px 20px 3px rgba(65, 65, 65, 0.6)",
          borderRadius: "10px",
          // position: "relative",
          px: 6,
          py: 2,
          margin: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            width: "100%",
            p: 2,
          }}
        >
          <Tooltip title="Open Encoding Filter" placement="top">
            <Button
              onClick={() => setOpenFilter(true)}
              sx={{
                backgroundColor: "#2e3887",
                color: "#fff",
                position: "absolute",
                right: 20,
                borderRadius: "10px",
                px: 2,
                py: 1,
                "&:hover": {
                  backgroundColor: "lightgray",
                  color: "black",
                },
              }}
            >
              <FilterListIcon sx={{ mr: 1 }} />
              Filter
            </Button>
          </Tooltip>
          <Divider>
            <Typography
              sx={{
                textTransform: "uppercase",
                fontSize: "25px",
              }}
            >
              Encoding Form
            </Typography>
          </Divider>
        </Box>

        <Divider
          sx={{
            backgroundColor: "#2e3887",
            borderRadius: "10px",
            width: "100%",
            py: 0.2,
            my: 2,
          }}
        />

        <Box
          sx={{
            p: 2,
            // ...(selectedTab === 0 ? { my: "2vh" } : { mb: "2vh" }),
            // "@media (max-height: 1080px)": {
            //   ...(selectedTab === 0 ? { my: "5vh" } : { mb: "5vh" }),
            // },
            my: "2vh",
            "@media (max-height: 1080px)": {
              my: "3vh",
            },
            backgroundColor: "#FFF",
            boxShadow: "3px 2px 15px 3px rgba(100, 100, 100, 0.8)",
            borderRadius: "10px",
          }}
        >
          <Box
            sx={{
              overflowY: "auto",
              // height: "40vh",
              width: "100%",
              // "@media (max-height: 1080px)": {
              //   height: "60vh",
              // },
            }}
          >
            <EncodingForm
              competencies={competencies}
              competencyDetails={competencyDetails}
              onDetailsUpdate={handleDetailsUpdate}
              submitFunction={handleSubmit}
              setOpenFilter={setOpenFilter}
              responseDetails={responseDetails}
              setResponseDetails={setResponseDetails}
              error={error} // Not being used
              loading={loading} // Not being used
            />
          </Box>
          <Typography
            sx={{
              color: "red",
              fontWeight: "bolder",
              fontSize: "15px",
              mb: 4,
            }}
          >
            {error}
          </Typography>
        </Box>
      </Box>
      <SnackbarComponent
        open={openSuccess}
        onClose={handleCloseSuccess}
        severity="success"
        message="Encoding Successful."
      />
      <SnackbarComponent
        open={openError}
        onClose={handleCloseError}
        severity="error"
        message={error}
      />
    </Box>
  );
}
